import ColorSwatch from "@/components/core/ColorSwatch/ColorSwatch"
import CONSTANTS from "@/constants/index"

import {
  getSelectedColor,
  getFirstSkuColor,
} from "@/components/ProductDetail/v3/ProductDetailView/utils"

const SwatchList = props => {
  const {
    colorsData: colorsDataList = [],
    isDiscontinued = false,
    sku = "",
    staticTexts: { discontinuedColorFinish = "", colorOrFinish = "" } = {},
    setSkuVariant = () => {},
    selectedColor = "",
  } = props

  const colorsData = getFirstSkuColor(colorsDataList)

  const handleKeyDown = (i, e) => {
    const { KEYCODE } = CONSTANTS
    const ele = e.target.parentNode.childNodes
    switch (e.keyCode) {
      case KEYCODE.UP:
        e.preventDefault()
        if (i > 0) ele[i - 1].focus()
        break
      case KEYCODE.DOWN:
        e.preventDefault()
        if (i < ele.length - 1) ele[i + 1].focus()
        break
      case KEYCODE.SPACE:
      case KEYCODE.ENTER:
        e.preventDefault()
        ele[i].querySelector("input").click()
        break
      default:
        break
    }
  }

  const selectedColorName = getSelectedColor(colorsData, sku)

  return (
    <>
      {colorsData.filter(c => !c.notApplicable).length > 0 ? (
        isDiscontinued ? (
          <div className="row no-gutters product-detail-page__finish-sample">
            <div
              className="product-detail-page__discontinued"
              tabIndex="0"
              aria-roledescription={`Finish Type ${selectedColorName} selected`}
            >
              <span className="discontinued-text">
                {discontinuedColorFinish}
              </span>
              <span className="discontinued-color-value">
                {selectedColorName}
              </span>
            </div>
          </div>
        ) : (
          <div className="row no-gutters product-detail-page__finish-sample">
            <div
              className="product-detail-page__finish"
              tabIndex="0"
              aria-roledescription={`Finish Type ${selectedColorName} selected`}
            >
              <span className="product-detail-page__finish_text">
                {colorOrFinish}
              </span>
              <span className="product-detail-page__finish_value">
                {selectedColorName}
              </span>
            </div>
          </div>
        )
      ) : null}
      {colorsData.filter(c => !c.notApplicable).length > 0 && (
        <div className="row no-gutters product-detail-page__color-swatch-main">
          <div
            id="finish-type-list"
            className="product-detail-page__color-swatch"
            role="listbox"
          >
            {colorsData
              .filter(c => !c.notApplicable)
              .map((item, i) => {
                const isChecked =
                  item.id === sku || selectedColor === item.label

                return (
                  <div
                    key={`${item?.id}-${i}`}
                    role="radio"
                    tabIndex={0}
                    aria-label={item.label}
                    aria-checked={isChecked ? true : false}
                    onKeyDown={e => handleKeyDown(i, e)}
                  >
                    <ColorSwatch
                      type="selector"
                      id={item.id}
                      name={item.name}
                      value={item.value}
                      label={item.label}
                      colorUrl={item.colorUrl}
                      checked={isChecked}
                      onClick={sku => setSkuVariant(sku)}
                      key={i}
                    />
                  </div>
                )
              })}
          </div>
        </div>
      )}
    </>
  )
}

export default SwatchList
